<template>
	<v-layout row wrap fill-height class="team">
		<v-flex xs12 md3>
			<v-card>
				<v-list class="py-0 admin__sidebar-menu" dark>
					<v-list-tile
						ripple
						to="/admin/documents/upload"
						avatar
						class="secondary"
					>
						<v-list-tile-avatar>
							<div class="v-icon secondary theme--dark">
								<fa-icon :icon="['far', 'upload']" size="xs" />
							</div>
						</v-list-tile-avatar>

						<v-list-tile-content>
							<v-list-tile-title
								>Upload Documents</v-list-tile-title
							>
						</v-list-tile-content>
					</v-list-tile>
				</v-list>

				<v-list
					class="py-0 admin__sidebar-menu"
					v-if="$vuetify.breakpoint.mdAndUp"
				>
					<v-list-tile
						ripple
						avatar
						v-for="document in documents"
						:key="document.id"
						:to="`/admin/documents/${document.id}`"
					>
						<v-list-tile-content>{{
							document.display_name
						}}</v-list-tile-content>
					</v-list-tile>
				</v-list>

				<v-list v-else class="py-0">
					<v-list-group
						:value="listOpen"
						@click="listOpen = !listOpen"
					>
						<v-list-tile
							slot="activator"
							class="decision-tree__category"
						>
							<v-list-tile-content>
								<v-list-tile-title
									>All Documents</v-list-tile-title
								>
							</v-list-tile-content>
						</v-list-tile>

						<v-list-tile
							ripple
							avatar
							v-for="document in documents"
							:key="document.id"
							@click="listOpen = false"
							:to="`/admin/documents/${document.id}`"
						>
							<v-list-tile-content>{{
								document.display_name
							}}</v-list-tile-content>
						</v-list-tile>
					</v-list-group>
				</v-list>
			</v-card>
		</v-flex>

		<v-flex xs12 md9 v-if="$route.fullPath.indexOf('/documents/') >= 0">
			<router-view :key="$route.fullPath"></router-view>
		</v-flex>
	</v-layout>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";

export default {
	data() {
		return {
			listOpen: false
		};
	},

	props: {
		id: {
			default: null
		}
	},

	computed: {
		...mapGetters("document_center", ["documents"])
	},

	methods: {
		...mapActions("document_center", [
			"getDocuments",
			"deleteDocument",
			"getCategories",
			"getPermissionGroups"
		]),
		...mapMutations("document_center", [
			"setCategories",
			"setDocuments",
			"setPermissionGroups"
		])
	},

	created() {
		this.getDocuments().then(({ data }) => {
			if (_.isArray(data) && data.length) {
				this.setDocuments(data);
			}
		});

		this.getPermissionGroups().then(({ data }) => {
			this.setPermissionGroups(data);
		});

		// this.getCategories({ admin: true }).then(({ data }) => {
		// 	this.setCategories(data);
		// });
	}
};
</script>
